import { useEffect, useRef } from "react";
/** Open a native <dialog> as modal while `open` is true (falls back to the `open` attribute where showModal is missing). */
export function useModalDialog(open) {
    const ref = useRef(null);
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        if (open && !element.open) {
            if (typeof element.showModal === "function")
                element.showModal();
            else
                element.setAttribute("open", "");
        }
        else if (!open && element.open) {
            if (typeof element.close === "function")
                element.close();
            else
                element.removeAttribute("open");
        }
    }, [open]);
    return ref;
}
/** True when a click on the <dialog> element itself landed outside its box (on the backdrop). */
export function isBackdropClick(event) {
    if (event.target !== event.currentTarget)
        return false;
    const rect = event.currentTarget.getBoundingClientRect();
    if (!rect.width && !rect.height)
        return false;
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
}
